<template>
  <el-dialog
    :key="formKey"
    :title="$t('role.viewUser')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    width="800px"
  >
    <!-- 搜索框 -->
    <div class="search" style="height: 60px">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" @submit.native.prevent>
        <el-form-item>
          <el-input
            v-model="searchForm.value"
            clearable
            style="width: 316px"
            :placeholder="$t('role.viewUserSearch')"
            @keyup.enter.native="handleSearch"
          >
            <div slot="suffix" class="search-input__icon--search">
              <svg-icon
                icon-class="search"
                class="search-icon cursor-p"
                @click="handleSearch"
              ></svg-icon>
            </div>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- /搜索框 -->
    <!-- 表格 -->
    <CustomTable
      ref="customTable"
      style="height: 505px"
      :loading="tableLoading"
      :table-data="tableData"
      :pagination="pagination"
      @handleSizeChange="handlePaginationChange"
      @handleCurrentChange="handlePaginationChange"
    >
      <el-table-column
        v-for="(cm, index) in tableColumns"
        :key="cm.field"
        :label="cm.name"
        :index="index"
        :width="cm.width"
        :fixed="cm.fixed"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row[cm.field] }}
        </template>
      </el-table-column>
    </CustomTable>
    <!-- /表格 -->
  </el-dialog>
</template>

<script>
import roleApi from "@/api/role/role";
export default {
  name: "RoleUser",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      formKey: new Date().getTime(),
      searchForm: {
        value: ""
      },
      tableLoading: false,
      tableColumns: [
        {
          name: this.$t("public.username"),
          field: "username",
          width: "200",
          fixed: false
        },
        {
          name: this.$t("userCenter.name"),
          field: "displayName",
          width: "auto",
          fixed: false
        },
        {
          name: this.$t("user.cellphone"),
          field: "cellphone",
          width: "200",
          fixed: false
        }
      ],
      tableData: [],
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  watch: {
    "searchForm.value"(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleSearch();
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取组织列表数据
    getList() {
      const params = {
        page: this.pagination.pageNum,
        size: this.pagination.pageSize,
        roleId: this.propData.id,
        search: this.searchForm.value
      };
      this.tableLoading = true;
      roleApi.getRoleUserList(params).then(
        res => {
          this.tableLoading = false;
          const { data } = res;
          if (res.success) {
            const { records = [], total = 0 } = data;
            this.tableData = records;
            this.pagination.total = Number(total);
          }
        },
        () => {
          this.tableLoading = false;
        }
      );
    },
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.getList();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.getList();
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .self-dialog-form {
  .el-dialog__body {
    max-height: calc(100vh - 264px) !important;
  }
}
</style>
